import { render, staticRenderFns } from "./TeyaCallback.vue?vue&type=template&id=807b713e"
import script from "./TeyaCallback.vue?vue&type=script&lang=js"
export * from "./TeyaCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports